export default {
  Business: {id: 1, name: 'orderType.business'},
  Consumer: {id: 2, name: 'orderType.consumer'}
}
